import { AccountObject, IAccountObjectArgs } from "../account-object/account-object.model";

export interface INotificationTemplateArgs extends IAccountObjectArgs {
    channel: string;
    title: string;
    subject: string;
    recipients: string;
    content: string;
    reportLayouts: Array<string>;
}

const defaults = () => ({
    channel: "",
    title: "",
    subject: "",
    recipients: "",
    content: "",
    reportLayouts: []
});

export class NotificationTemplate extends AccountObject {
    channel: string;
    title: string;
    subject: string;
    recipients: string;
    content: string;
    reportLayouts: Array<string>;

    constructor(args: INotificationTemplateArgs = {} as any) {
        super({...defaults(), ...args});
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/notification-template/notification-template.model.ts